import store from "../../store/index";
import customModal from "../customModal/customModal.vue";
import moment from "moment";

export default {
  name: "TaskListModal",
  props: {
    criticalInfo: {
      type: Object,
      default: () => ({}),
    },
    formPage: {
      type: String,
      default: "",
    }
  },
  components: { customModal },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      idToken: store.getters.getIdToken,
      defaultdate: "",
      defaultTime: "",
      headerValues: {},
    };
  },
  mounted() {
    console.log("Critical Info:", this.criticalInfo);
    this.defaultdate = localStorage.getItem("dateformat");
    this.defaultTime = localStorage.getItem("timeformat");
    this.filter();
  },
  methods: {
    filter(date) {
                  if (date) {
                    return moment(date).format(this.defaultdate)
                  }
                },
                toTime(data) {
          if (data) {
            return moment(data).format(this.defaultTime);
          }
        },
    closeModal() {
      this.$emit("closeModal");
    },
  },
};